<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<div class="box1">
<h1 class="title"><strong>Sewn Toy Tales</strong></h1>
</div>
<h1 class="title1">12 fun characters to make and love</h1>
<p class="center"><img alt="" src="OEBPS/images/2-1.jpg"/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
<p class="center"><a href="http://www.rucraft.co.uk" target="_blank">www.rucraft.co.uk</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?e1bdc328